// Router-relative paths only. Do not exempt prefixes or protected subroutes.
export const isPublicAuthRoute = pathname => ['/login', '/privacy-policy'].includes(String(pathname).replace(/\/$/, ''));
